import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import { LeadFormProvider } from "contexts/LeadFormContext";
import NotFound from "pages/NotFound";
import InteractiveCatalog from './pages/interactive-catalog';
import ContactConsultation from './pages/contact-consultation';
import ArtisanalProcess from './pages/artisanal-process';
import ProjectGallery from './pages/project-gallery';
import AboutUs from './pages/about-us';
import Homepage from './pages/homepage';
import Materials from './pages/materials';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <LeadFormProvider>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<Homepage />} />
        <Route path="/interactive-catalog" element={<InteractiveCatalog />} />
        <Route path="/contact-consultation" element={<ContactConsultation />} />
        <Route path="/artisanal-process" element={<ArtisanalProcess />} />
        <Route path="/project-gallery" element={<ProjectGallery />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/materials" element={<Materials />} />
        <Route path="/homepage" element={<Homepage />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </LeadFormProvider>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
